import { v1 as uuid } from 'uuid';
export class DataRecord {
    constructor(_class, kind, id) {
        this.availability = [];
        this.kind = kind;
        this.type = _class;
        this._id = id || uuid();
    }
}
export var RecordKind;
(function (RecordKind) {
    RecordKind["Schema"] = "Schema";
    RecordKind["Product"] = "Product";
    RecordKind["ProductGroup"] = "ProductGroup";
    RecordKind["Option"] = "Option";
    RecordKind["OptionGroup"] = "OptionGroup";
    RecordKind["OclConstraint"] = "OclConstraint";
    RecordKind["ExternalField"] = "ExternalField";
    RecordKind["CompatibilityTable"] = "CompatibilityTable";
    RecordKind["OclFilter"] = "OclFilter";
    RecordKind["JsFilter"] = "JsFilter";
})(RecordKind || (RecordKind = {}));
export function productTypeGuard(record) {
    return record.kind === RecordKind.Product;
}
export function productGroupTypeGuard(record) {
    return record.kind === RecordKind.ProductGroup;
}
export function optionTypeGuard(record) {
    return record.kind === RecordKind.Option;
}
export function optionGroupTypeGuard(record) {
    return record.kind === RecordKind.OptionGroup;
}
//# sourceMappingURL=record.js.map